import React, { useState, useEffect } from "react";
import danger from "../images/Danger.png";
import catalogoEmojis from "../images/catalogo-emojis-new.webp";
import { useDataContext } from "../contexts/AuthContext";
import { getSizeById, editSize, getSizesByOrderId } from "../services/api";
import GuiaTallesModal from "./GuiaTallesModal";
import Swal from "sweetalert2";
import styles from "../styles/SizeFlow.module.css";
import {
  CurrentSizeCard,
  EmojiTipsCard,
  SizeAlertBanner,
  SizeConfirmationModal,
  SizeField,
  SizeFlowShell,
  SizeFooter,
  SizeSections,
} from "./SizeFlowShared";

const EditarTalle = ({
  orderItemId,
  sizeId,
  setEditingSizeId,
  onClose,
  sizeName,
  moldingId,
  orderItemCategoryId,
}) => {
  const [apodo, setApodo] = useState("");
  const [currentCustomerId, setCurrentCustomerId] = useState("");
  const [personalizado, setPersonalizado] = useState("");
  const [emojiOpen, setEmojiOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [newSize, setNewSize] = useState("");
  const { contextData } = useDataContext();
  const { customer } = contextData;
  const customer_id = customer.id;
  const [currentSize, setCurrentSize] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [tallesPorMolderia, setTallesPorMolderia] = useState({});
  const [visibilidadMolderia, setVisibilidadMolderia] = useState({});
  const [tallesSeleccionados, setTallesSeleccionados] = useState({});
  const [molderiaModalAbierta, setMolderiaModalAbierta] = useState(null);

  const abrirModalMolderia = (molderia) => setMolderiaModalAbierta(molderia);
  const cerrarModalMolderia = () => setMolderiaModalAbierta(null);

  useEffect(() => {
    const fetchSizes = async () => {
      try {
        const data = await getSizesByOrderId(customer.order_id, moldingId, orderItemCategoryId);
        setTallesPorMolderia(data);
        const visibilidadInicial = {};
        const seleccionInicial = {};
        Object.keys(data).forEach((molderia) => {
          visibilidadInicial[molderia] = false;
          seleccionInicial[molderia] = data[molderia].map(() => false);
        });
        setVisibilidadMolderia(visibilidadInicial);
        setTallesSeleccionados(seleccionInicial);
      } catch (error) {
        console.error("Error al obtener talles dinámicos:", error);
      }
    };

    fetchSizes();
  }, [customer.order_id, moldingId, orderItemCategoryId]);

  const toggleSeccion = (molderia) => {
    setVisibilidadMolderia((prev) => ({
      ...prev,
      [molderia]: !prev[molderia],
    }));
  };

  const handleTalleChange = (molderia, index) => {
    const nuevoEstado = {};

    Object.keys(tallesSeleccionados).forEach((mol) => {
      if (mol === molderia) {
        nuevoEstado[mol] = tallesSeleccionados[mol].map((_, i) => i === index);
      } else {
        nuevoEstado[mol] = tallesSeleccionados[mol].map(() => false);
      }
    });

    setTallesSeleccionados(nuevoEstado);
  };

  const obtenerTallesSeleccionados = () => {
    const codigos = [];
    let talleSeleccionado = null;

    Object.entries(tallesSeleccionados).forEach(([molderia, seleccionados]) => {
      if (!Array.isArray(seleccionados)) return;

      seleccionados.forEach((isSelected, index) => {
        if (isSelected) {
          const talle = tallesPorMolderia[molderia]?.[index];
          if (talle) {
            codigos.push(talle.code);
            if (!talleSeleccionado) {
              talleSeleccionado = talle;
            }
          }
        }
      });
    });

    return {
      codigos,
      width: talleSeleccionado?.max_width ?? null,
      height: talleSeleccionado?.max_height ?? null,
    };
  };

  useEffect(() => {
    if (!orderItemId) {
      return;
    }
    const fetchSizeInfo = async (targetSizeId) => {
      const data = await getSizeById(targetSizeId);
      setApodo(data.nickname || "");
      setCurrentCustomerId(data.customer_id || customer_id);
      setPersonalizado(data.initials || "");
      setCurrentSize(data.size || "");
    };

    fetchSizeInfo(sizeId);
  }, [orderItemId, sizeId, customer_id]);

  const uploadSizes = async (e) => {
    e.preventDefault();

    if (!customer_id) {
      console.error("customer_id no está disponible");
      return;
    }

    const { codigos, width, height } = obtenerTallesSeleccionados();
    if (!Array.isArray(codigos) || codigos.length === 0) {
      Swal.fire({
        icon: "warning",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Atención",
        text: "Debes seleccionar un talle.",
      });
      return;
    } else if (sizeName === "") {
      Swal.fire({
        icon: "warning",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Atención",
        text: "Debes seleccionar un alumno.",
      });
      return;
    }

    const data = {
      name: sizeName,
      nickname: apodo,
      initials: personalizado,
      comments: null,
      gender: "f",
      width,
      height,
      size: codigos.join(","),
      order_item_id: orderItemId,
      created_by_id: customer_id,
      customer_id: currentCustomerId,
    };

    try {
      await editSize(data, sizeId);
      Swal.fire({
        icon: "success",
        iconColor: "#d54ab7",
        title: "Carga correcta!",
        text: "¡Talle editado correctamente!",
        confirmButtonColor: "#0071ce",
      }).then(async (result) => {
        if (result.isConfirmed) {
          handleCancelarEnviar();
        }
      });
    } catch (error) {
      console.error("Error al crear el talle:", error.message);
      Swal.fire({
        icon: "error",
        title: "Error al editar talles",
        text: "Hubo un problema al editar los talles. Por favor, intenta de nuevo más tarde.",
      });
    }
  };

  const handleApodoChange = (e) => setApodo(e.target.value);
  const handlePersonalizadoChange = (e) => setPersonalizado(e.target.value);
  const toggleEmojiMenu = () => setEmojiOpen(!emojiOpen);

  const handleEnviarClick = (e) => {
    e.preventDefault();
    setShowModal(true);
    if (editMode === false) {
      if (newSize === currentSize) {
        console.log("El tamaño es el mismo que ya estaba");
        return;
      }
      setNewSize(currentSize);
    }
  };

  const handleCancelarEnviar = () => {
    setShowModal(false);
    setEditingSizeId(null);
  };

  const obtenerTallesSeleccionadosPorMolderia = () => {
    const resultado = {};

    Object.entries(tallesSeleccionados).forEach(([molderia, seleccionados]) => {
      seleccionados.forEach((isSelected, index) => {
        if (isSelected) {
          const talle = tallesPorMolderia[molderia][index];
          if (talle) {
            if (!resultado[molderia]) {
              resultado[molderia] = [];
            }
            resultado[molderia].push(talle.code);
          }
        }
      });
    });

    return resultado;
  };

  const hasSelectedSizes = Object.values(obtenerTallesSeleccionadosPorMolderia()).flat().length > 0;

  return (
    <>
      <SizeFlowShell
        title="Editar"
        titleAccent="talles"
        subtitle="Podés actualizar apodo, personalizado y cambiar el talle si necesitás corregirlo antes de confirmar."
        eyebrow="Formulario de edición"
        onClose={onClose}
      >
        <SizeAlertBanner
          icon={danger}
          title="Revisá bien antes de confirmar la edición"
          text="Si cambiás el talle, elegí uno nuevo desde la moldería correcta y verificá que coincida con la prenda cargada."
        />

        <div className={styles.fieldCard}>
          <span className={styles.cardEyebrow}>Datos actuales</span>
          <p className={styles.cardTitle}>Información de la prenda</p>
          <div className={`${styles.fieldGrid} ${styles.fieldGridTwo}`}>
            <SizeField label="Alumno">
              <input
                name="name"
                type="text"
                className={styles.readonlyInput}
                id="alumno"
                value={sizeName}
                disabled
              />
            </SizeField>

            <SizeField label="Apodo" hint="Si no querés que lleve apodo, podés dejar este campo vacío.">
              <input
                name="nickname"
                type="text"
                className={styles.input}
                id="apodo"
                value={apodo}
                onChange={handleApodoChange}
              />
            </SizeField>

            <SizeField
              label="Personalizado"
              hint="Aclaraciones extra como modalidad, opcionales o números personalizados."
            >
              <textarea
                name="comments"
                className={styles.textarea}
                id="personalizado"
                value={personalizado}
                onChange={handlePersonalizadoChange}
              />
            </SizeField>
          </div>
        </div>

        <EmojiTipsCard emojiOpen={emojiOpen} onToggle={toggleEmojiMenu} image={catalogoEmojis} />

        <CurrentSizeCard
          currentSize={currentSize}
          editMode={editMode}
          onEdit={() => setEditMode(true)}
          onCancelEdit={() => {
            setNewSize(currentSize);
            setEditMode(false);
          }}
        />

        {editMode ? (
          <SizeSections
            title="Elegí el nuevo talle"
            hint="Abrí la moldería correcta y seleccioná el talle que reemplaza al actual para {prenda}."
            prenda={sizeName}
            tallesPorMolderia={tallesPorMolderia}
            visibilidadMolderia={visibilidadMolderia}
            tallesSeleccionados={tallesSeleccionados}
            onToggleSeccion={toggleSeccion}
            onTalleChange={handleTalleChange}
            onOpenGuide={abrirModalMolderia}
          />
        ) : null}

        <SizeFooter onBack={onClose} onSubmit={handleEnviarClick} submitLabel="Enviar" />
      </SizeFlowShell>

      {molderiaModalAbierta ? (
        <GuiaTallesModal
          order_id={customer.order_id}
          molderia={molderiaModalAbierta}
          onClose={cerrarModalMolderia}
        />
      ) : null}

      <SizeConfirmationModal
        open={showModal}
        title="¿Confirmás que los datos a editar son correctos?"
        subtitle="Revisá los cambios antes de confirmar la edición del talle."
        alumno={sizeName}
        apodo={apodo}
        personalizado={personalizado}
        tallesPorMolderia={hasSelectedSizes ? obtenerTallesSeleccionadosPorMolderia() : { "Talle actual": [currentSize] }}
        onClose={handleCancelarEnviar}
        onConfirm={uploadSizes}
        confirmLabel="Confirmar"
      />
    </>
  );
};

export default EditarTalle;
